import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import enTranslations from './locales/en/translation.json'
import nlTranslations from './locales/nl/translation.json'
import faTranslations from './locales/fa/translation.json'
import arTranslations from './locales/ar/translation.json'
import { UI_LANGUAGE_CODES, isRtlLanguage } from './constants/uiLanguages'

const SUPPORTED = [...UI_LANGUAGE_CODES]
const storedLng =
  typeof window !== 'undefined' ? window.localStorage.getItem('i18nextLng') : null
const initialLng = SUPPORTED.includes(storedLng) ? storedLng : 'en'

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enTranslations },
      nl: { translation: nlTranslations },
      fa: { translation: faTranslations },
      ar: { translation: arTranslations },
    },
    lng: initialLng,
    fallbackLng: 'en',
    supportedLngs: SUPPORTED,
    interpolation: {
      escapeValue: false // react already does escaping
    },
    react: {
      useSuspense: false
    }
  })

/** Avoid RTL/LTR flash before React mounts */
if (typeof document !== 'undefined') {
  const lng = (i18n.language || initialLng || 'en').split('-')[0].toLowerCase()
  document.documentElement.lang = lng
  document.documentElement.dir = isRtlLanguage(lng) ? 'rtl' : 'ltr'
}

export default i18n
